export function getAuth() {
  return JSON.parse(localStorage.getItem("authentication"));
}
